
namespace RioERP.Carts {
    export class CartProductBillingItemsTaxColumns {
        static columnsKey = 'Carts.CartProductBillingItemsTax';
    }
}